import { render, staticRenderFns } from "./CommentsArea.vue?vue&type=template&id=59ba73cc&scoped=true"
import script from "./CommentsArea.vue?vue&type=script&lang=js"
export * from "./CommentsArea.vue?vue&type=script&lang=js"
import style0 from "./CommentsArea.vue?vue&type=style&index=0&id=59ba73cc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ba73cc",
  null
  
)

export default component.exports